// GROQ queries for all editable content
export const heroQuery = `*[_type == "hero"][0]{ headline, subtitle }`;

export const siteConfigQuery = `*[_type == "siteConfig"][0]{
  phone, phoneRaw, email, whatsapp, address, hours, tagline, facebook, instagram, since, logo
}`;

export const doctorsQuery = `*[_type == "doctor"] | order(order asc, name asc){
  _id, name, "slug": slug.current, role, image, bio, expertise, quote, stats, featured, order
}`;

export const servicesQuery = `*[_type == "serviceCategory"] | order(order asc){
  _id, key, title, items, image, order
}`;

export const postsQuery = `*[_type == "blogPost" && defined(slug.current)] | order(publishedAt desc){
  _id, title, "slug": slug.current, excerpt, image, tag, publishedAt, readTime, body
}`;

export const postBySlugQuery = `*[_type == "blogPost" && slug.current == $slug][0]{
  _id, title, "slug": slug.current, excerpt, image, tag, publishedAt, readTime, body
}`;

export const galleryQuery = `*[_type == "galleryItem"] | order(order asc, _createdAt desc){
  _id, image, caption, order
}`;

export const testimonialsQuery = `*[_type == "testimonial"] | order(order asc, _createdAt desc){
  _id, name, place, stars, text, order
}`;

export const awardsQuery = `*[_type == "award"] | order(order asc, _createdAt desc){
  _id, title, text, order
}`;

export const featuresQuery = `*[_type == "feature"] | order(order asc){ _id, no, title, text, order }`;

export const missionQuery = `*[_type == "missionPillar"] | order(order asc){ _id, no, title, text, order }`;

export const whyQuery = `*[_type == "whyReason"] | order(order asc){ _id, title, text, order }`;

export const allContentQuery = `{
  "hero": ${heroQuery},
  "siteConfig": ${siteConfigQuery},
  "doctors": ${doctorsQuery},
  "services": ${servicesQuery},
  "posts": ${postsQuery},
  "gallery": ${galleryQuery},
  "testimonials": ${testimonialsQuery},
  "awards": ${awardsQuery},
  "features": ${featuresQuery},
  "mission": ${missionQuery},
  "why": ${whyQuery}
}`;
